// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Tmln","superFancy":"_2m9-A","bg":"oQhSK","icon":"QduV1"};